import styles from "./CreateDeliveries.module.css";
import { useState, useEffect } from "react";
import axiosInstance from "../../../Configuration/axiosInstance";
import SuccessDialogue from "../../../Components/Shared/SuccessDialog/SuccessDialog";
import LoadingSpinner from "../../../Components/Shared/Loader/Loader";
import ProductsModal from "../../../Components/ProductsModal/ProductsModal";

const CreateDeliveries = () => {
  const [run, setRun] = useState();
  const [vehicle, setVehicle] = useState();
  const [orders, setOrders] = useState([]);
  const [stateChanged, setStateChanged] = useState(false);
  const [loading, setLoading] = useState(true);
  const [deliveryOrder, setDeliveryOrders] = useState([]);
  const [date, setDate] = useState(null);
  const [deliveryDate, setDeliveryDate] = useState();
  const [searchCondition, setSearchCondition] = useState(false);
  const [open, setOpen] = useState(false);
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState("");
  const [show, setShow] = useState(false);
  const [products, setProducts] = useState([]);
  const [comments, setComments] = useState("");
  const [totalWeight, setTotalWeight] = useState();
  const [selectedOrders, setSelectedOrders] = useState([]);
  const [searchCriteria, setSearchCriteria] = useState({
    orderNumber: null,
    date: null,
  });
  const [order, setOrder] = useState();
  const [orderNumber, setOrderNumber] = useState();
  
  // ✅ NEW: Tomorrow's date state and info
  const [tomorrowDate, setTomorrowDate] = useState("");
  const [showAllOrders, setShowAllOrders] = useState(false);

  const [users, setUsers] = useState([]);
  const [assignedUsers, setAssignedUsers] = useState([]);

  // ✅ NEW: Calculate tomorrow's date
  useEffect(() => {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    const tomorrowFormatted = tomorrow.toISOString().split('T')[0]; // YYYY-MM-DD format
    setTomorrowDate(tomorrowFormatted);
    
    // ✅ Auto-set delivery date to tomorrow
    setDeliveryDate(tomorrowFormatted);
    
    console.log("Tomorrow's date:", tomorrowFormatted);
  }, []);

  useEffect(() => {
    axiosInstance
      .get("/user")
      .then((res) => {
        const deliveryUsers = res.data.data.filter(
          (user) => user.role === "delivery"
        );
        setUsers(deliveryUsers);
      })
      .catch(() => setUsers([]));
  }, []);

  useEffect(() => {
    setLoading(true);
    
    // ✅ MODIFIED: Build query parameters - filter for tomorrow's orders by default
    const params = new URLSearchParams();
    
    // ✅ NEW: If not showing all orders, filter for tomorrow only
    if (!showAllOrders && tomorrowDate) {
      params.append('date', tomorrowDate);
      console.log("Filtering orders for tomorrow:", tomorrowDate);
    } else {
      // Use custom search criteria when showing all orders
      if (searchCriteria.date && searchCriteria.date !== null && searchCriteria.date.trim() !== "") {
        params.append('date', searchCriteria.date);
      }
    }
    
    if (searchCriteria.orderNumber && searchCriteria.orderNumber !== null && searchCriteria.orderNumber.toString().trim() !== "") {
      params.append('orderNumber', searchCriteria.orderNumber);
    }
    
    const queryString = params.toString();
    const url = queryString 
      ? `delivery/deliverOrder?${queryString}`
      : 'delivery/deliverOrder';

    console.log("Making request to:", url);

    axiosInstance
      .get(url)
      .then((res) => {
        setOrders(res.data.data);
        setLoading(false);
        
        if (!showAllOrders) {
          console.log(`Loaded ${res.data.data.length} orders scheduled for tomorrow (${tomorrowDate})`);
        } else {
          console.log(`Loaded ${res.data.data.length} pending orders (all dates)`);
        }
      })
      .catch((error) => {
        console.error("Error fetching pending orders:", error);
        setLoading(false);
        setError("Failed to load pending orders");
      });
  }, [stateChanged, searchCriteria, tomorrowDate, showAllOrders]);

  const handleChange = (e) => {
    setRun(e.target.value);
  };

  const handleVehicleChange = (e) => {
    setVehicle(e.target.value);
  };

  const handleDate = (e) => {
    setDate(e.target.value);
  };

  const handleChecked = (e, id) => {
    if (e.target.checked) {
      setDeliveryOrders((prevValues) => [
        ...prevValues,
        Number(e.target.value),
      ]);
      setSelectedOrders((prevValues) => [
        ...prevValues,
        orders.find((i) => i.orderNumber === id),
      ]);
    } else if (!e.target.checked) {
      console.log("unchecked", id);
      setDeliveryOrders((prevValues) =>
        prevValues.filter((i) => i !== Number(e.target.value))
      );
      setSelectedOrders((prevValues) =>
        prevValues.filter((i) => i.orderNumber !== id)
      );
    }
  };

  const handleOrderNumber = (e) => {
    setOrderNumber(e.target.value);
  };

  const clearInputFields = () => {
    setRun("");
    setDeliveryDate(tomorrowDate); // Reset to tomorrow
    setVehicle("");
  };

  const submitDelivery = (e) => {
    e.preventDefault();

    setLoading(true);
    setError(null);

    if (deliveryOrder.length === 0) {
      setError("You have to assign at least one delivery to a run");
      setLoading(false);
      return;
    }

    if (run.trim() === "") {
      setError("Run field cannot be empty");
      setLoading(false);
      return;
    }

    axiosInstance
      .post(`delivery`, {
        order: deliveryOrder,
        run,
        vehicle: vehicle,
        date: deliveryDate,
        comments: comments,
        assignedUsers,
      })
      .then((res) => {
        setLoading(false);
        setSuccessMessage(res.data.message);
        setOpen(true);
        setTimeout(() => {
          setOpen(false);
          clearInputFields();
          setDeliveryOrders([]);
          setSelectedOrders([]);
          setStateChanged((prevValue) => !prevValue);
          setSuccessMessage("");
        }, 2000);
      })
      .catch((error) => {
        setLoading(false);
        setError("An error occurred during the submission.");
      });

    setTimeout(() => {
      setError(null);
    }, 2000);
  };

  const handleDeliveryDate = (e) => {
    setDeliveryDate(e.target.value);
  };

  const handleFilter = () => {
    if (date) {
      setSearchCriteria((data) => ({ ...data, date: date }));
    }
    if (orderNumber) {
      setSearchCriteria((data) => ({ ...data, orderNumber: orderNumber }));
    }
    setSearchCondition(true);
    setStateChanged((prevValue) => !prevValue);
  };

  const clearFilters = (btnAction) => {
    if (btnAction === "date") {
      setSearchCriteria((preValue) => ({ ...preValue, date: null }));
      setDate("");
    }
    if (btnAction === "orderNumber") {
      setSearchCriteria((preValue) => ({ ...preValue, orderNumber: null }));
      setOrderNumber("");
    }
    setStateChanged((prevValue) => !prevValue);
  };

  // ✅ NEW: Toggle between tomorrow's orders and all orders
  const toggleOrderView = () => {
    setShowAllOrders(!showAllOrders);
    setSearchCriteria({ orderNumber: null, date: null }); // Clear search when toggling
    setDate("");
    setOrderNumber("");
    setSearchCondition(false);
    setStateChanged((prevValue) => !prevValue);
  };

  const clearOrder = (id) => {
    setDeliveryOrders((orders) => orders.filter((i) => i !== id));
    setSelectedOrders((orders) => orders.filter((i) => i.orderNumber !== id));
    document.getElementById(id).checked = false;
  };

  const handleModal = (i, order) => {
    setOrder(order);
    setProducts(i);
    setShow(true);
  };

  const calculateWeight = () => {
    const weights = selectedOrders.map((i) =>
      i.products.map((i) => {
        return { weight: i.product.weight, quantity: i.quantity };
      })
    );
    let total = 0;
    console.log(weights);

    weights.forEach((innerArray) => {
      innerArray.forEach((obj) => {
        console.log(obj);
        total += obj.weight * obj.quantity;
        console.log(obj.weight * obj.quantity);
        console.log(total);
      });
    });
    setTotalWeight(total);
  };

  // ✅ NEW: Format tomorrow's date for display
  const formatTomorrowDate = () => {
    if (!tomorrowDate) return "";
    const tomorrow = new Date(tomorrowDate);
    return tomorrow.toLocaleDateString('en-AU', { 
      weekday: 'long', 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric' 
    });
  };

  return (
    <div>
      <SuccessDialogue msg={successMessage} show={open} />
      
      {/* ✅ NEW: Enhanced header with tomorrow's date info */}
      <div className={styles.headerSection}>
        <h2>Create New Deliveries</h2>
        <div className={styles.dateInfo}>
          {!showAllOrders ? (
            <div className={styles.tomorrowInfo}>
              <span className={styles.dateLabel}>📅 Showing orders for tomorrow:</span>
              <span className={styles.dateValue}>{formatTomorrowDate()}</span>
            </div>
          ) : (
            <div className={styles.allOrdersInfo}>
              <span className={styles.dateLabel}>📋 Showing all pending orders</span>
            </div>
          )}
        </div>
      </div>

      {/* ✅ MODIFIED: Enhanced search strip with view toggle */}
      <div className={styles.searchStrip}>
        <div className={styles.viewToggle}>
          <button 
            className={`${styles.toggleBtn} ${!showAllOrders ? styles.active : ''}`}
            onClick={toggleOrderView}
          >
            {!showAllOrders ? "📅 Tomorrow's Orders" : "📋 Switch to Tomorrow's Orders"}
          </button>
          {showAllOrders && (
            <button 
              className={`${styles.toggleBtn} ${styles.secondary}`}
              onClick={toggleOrderView}
            >
              ← Back to Tomorrow's Orders
            </button>
          )}
        </div>

        {/* ✅ MODIFIED: Only show search when viewing all orders */}
        {showAllOrders && (
          <div className={styles.searchControls}>
            <label>Search By Order Date</label>
            <input
              type="date"
              onChange={handleDate}
              value={date}
              className={styles.datePicker}
            />
            <label>Search By Order Number</label>
            <input type="number" value={orderNumber} onChange={handleOrderNumber} />
            <button className="searchBtn" onClick={handleFilter}>
              Search
            </button>
          </div>
        )}

        {/* ✅ Search criteria display */}
        {searchCondition && showAllOrders && (
          <div className={styles.activeFilters}>
            {searchCriteria.date && (
              <span
                className="searchSpan"
                style={{ marginRight: "15px", marginLeft: "5px" }}
              >
                📅 {searchCriteria.date}
                <button
                  className="spanBtn"
                  onClick={() => clearFilters("date")}
                >
                  {" "}
                  &times;
                </button>
              </span>
            )}
            {searchCriteria.orderNumber && (
              <span className="searchSpan">
                📦 {searchCriteria.orderNumber}
                <button
                  className="spanBtn"
                  onClick={() => clearFilters("orderNumber")}
                >
                  &times;
                </button>
              </span>
            )}
          </div>
        )}
      </div>

      {show && (
        <ProductsModal
          show={show}
          setShow={setShow}
          update={true}
          order={order}
          products={products}
          title={"Products in the Current Order"}
        />
      )}

      {loading ? (
        <LoadingSpinner />
      ) : (
        <div className={styles.orderTable} style={{ display: "flex" }}>
          <div>
            {/* ✅ ENHANCED: Order count with context */}
            <h3>
              {!showAllOrders 
                ? `Tomorrow's Orders (${orders.length})` 
                : `All Pending Orders (${orders.length})`
              }
            </h3>
            
            {/* ✅ NEW: Help text for tomorrow's orders */}
            {!showAllOrders && orders.length === 0 && (
              <div className={styles.noOrdersMessage}>
                <p>📅 No orders scheduled for tomorrow ({tomorrowDate})</p>
                <p>💡 Orders may need to be assigned dates first, or try viewing all orders.</p>
                <button 
                  className={styles.showAllBtn}
                  onClick={toggleOrderView}
                >
                  View All Pending Orders
                </button>
              </div>
            )}

            {orders.length > 0 && (
              <div className={styles.orderBody}>
                <table>
                  <thead>
                    <tr>
                      <th>Select </th>
                      <th>Order Number</th>
                      <th>Business Name</th>
                      <th>Delivery Address</th>
                      <th>SKU's</th>
                      <th>Order Date</th>
                      {/* ✅ NEW: Show order type for context */}
                      <th>Type</th>
                    </tr>
                  </thead>
                  <tbody>
                    {orders?.map((i, index) => (
                      <tr key={index}>
                        <td>
                          <input
                            type="checkbox"
                            onChange={(e) => handleChecked(e, i?.orderNumber)}
                            id={i?.orderNumber}
                            value={i?.orderNumber}
                            checked={deliveryOrder.includes(i?.orderNumber)}
                          />
                        </td>
                        <td>{i?.orderNumber}</td>
                        <td>{i?.customer?.businessName}</td>
                        <td>{i?.customer?.address}</td>
                        <td>
                          <button
                            className="popupBtn"
                            onClick={() => {
                              handleModal(i?.products, i);
                            }}
                          >
                            {i?.products?.length}
                          </button>
                        </td>
                        <td>{new Date(i?.date).toLocaleDateString("en-GB")}</td>
                        {/* ✅ NEW: Order type indicators */}
                        <td>
                          <span className={styles.orderTypeBadge}>
                            {i?.isPickup ? "📦 Pickup" : "🚚 Delivery"}
                          </span>
                          {i?.scheduled && (
                            <span className={styles.scheduledBadge}>🔄</span>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>

          <div>
            <h3>Selected Orders ({selectedOrders.length})</h3>
            <div className={styles.orderBody}>
              <table>
                <thead>
                  <th>Order Number</th>
                  <th>SKU's</th>
                  <th>Actions</th>
                </thead>
                <tbody>
                  {selectedOrders?.map((i, index) => (
                    <tr key={index}>
                      <td>{i.orderNumber}</td>
                      <td>
                        <button
                          className="popupBtn"
                          onClick={() => {
                            handleModal(i?.products, i);
                          }}
                        >
                          {i?.products?.length}
                        </button>
                      </td>
                      <td>
                        <button
                          className={styles.deleteBtn}
                          onClick={() => clearOrder(i.orderNumber)}
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <hr />
              <div style={{ display: "flex" }}>
                <button
                  style={{ backgroundColor: "blue", color: "white" }}
                  onClick={calculateWeight}
                >
                  Calculate weight
                </button>
                <div
                  style={{
                    textAlign: "center",
                    backgroundColor: "black",
                    padding: "5px",
                    color: "white",
                    marginLeft: "5px",
                    borderRadius: "5px",
                  }}
                >
                  Total Weight: {totalWeight}kg
                </div>
              </div>
            </div>
          </div>

          <form onSubmit={submitDelivery}>
            <h3>Assign To</h3>
            <div className={styles.assignStyle}>
              {/* ✅ ENHANCED: Delivery date defaults to tomorrow */}
              <label>Expected Delivery Date</label>
              <input
                type="date"
                value={deliveryDate}
                onChange={handleDeliveryDate}
                min={tomorrowDate} // Prevent selecting past dates
              />
              <small className={styles.dateHint}>
                💡 Defaults to tomorrow ({new Date(tomorrowDate).toLocaleDateString('en-GB')})
              </small>
              
              <label>Run Name </label>
              <input
                type="text"
                value={run}
                onChange={handleChange}
              />
              <label>Vehicle Rego </label>
              <input
                type="text"
                value={vehicle}
                onChange={handleVehicleChange}
              />
              <label>Assign Driver(s)</label>
              <select
                multiple
                value={assignedUsers}
                onChange={(e) => {
                  const options = Array.from(
                    e.target.selectedOptions,
                    (option) => option.value
                  );
                  setAssignedUsers(options);
                }}
                style={{
                  width: "100%",
                  height: "150px", // Reduced height
                  padding: "8px",
                  fontSize: "14px",
                  border: "1px solid #ccc",
                  borderRadius: "4px",
                  backgroundColor: "#fff",
                }}
              >
                {users.map((user) => (
                  <option key={user._id} value={user._id}>
                    {user.name || user.email.split('@')[0]}
                  </option>
                ))}
              </select>
              <small className={styles.driverHint}>
                💡 Hold Ctrl/Cmd to select multiple drivers
              </small>
              
              <br />
              <label>Comments: </label>
              <textarea
                type="text"
                value={comments}
                rows={6}
                placeholder="Special delivery instructions, route notes, etc."
                onChange={(e) => setComments(e.target.value)}
              />
              <br />

              <button className={styles.myButton} type="submit">
                Create Delivery Run
              </button>
              {error && <div className="error-message">{error}</div>}
            </div>
          </form>
        </div>
      )}
    </div>
  );
};

export default CreateDeliveries;
